export default {
      id: "funnel-usage",
      viewBox: "0 0 12 10",
      url: __webpack_public_path__ + "sprite-46b249.svg#funnel-usage",
      toString: function () {
        return this.url;
      }
    }